// Grille des métafields de la fiche produit (snippet product-features). Au changement de déclinaison,
// le thème recalcule la section et publie variant-change avec le HTML obtenu : la grille y est reprise
// telle quelle, déjà calculée pour la nouvelle déclinaison.
if (!customElements.get('product-features')) {
  customElements.define(
    'product-features',
    class ProductFeatures extends HTMLElement {
      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.section) return;
          const source = event.data.html.getElementById(this.id);
          if (source) this.innerHTML = source.innerHTML;
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }
    }
  );
}
